import type { RichTextBlockProps } from '../types';
import { theme, sectionColors } from '../theme';
import { RichParagraph } from '../richText';

/**
 * Rich text. Renders an optional heading + paragraphs. A paragraph is plain words or formatted
 * text (bold, a font, a list, a link — richText.tsx), drawn as React elements from the kept tags
 * only. Deliberately does NOT use dangerouslySetInnerHTML — only the raw_html shim does.
 */
export function RichTextBlock(props: RichTextBlockProps) {
  const { heading, paragraphs, align } = props;
  const center = align === 'center';
  // Light by default (no band): transparent background, brand text color.
  const colors = sectionColors(props, { bg: 'transparent', text: theme.text });
  return (
    <div className="px-6 py-12" style={{ ...colors, fontFamily: theme.bodyFont }}>
      <div className={`blk-prose mx-auto max-w-3xl${center ? ' text-center' : ''}`}>
        {heading ? <h2 className="mb-4 text-2xl font-semibold" style={{ fontFamily: theme.headingFont }}>{heading}</h2> : null}
        {paragraphs.map((p, i) => (
          <RichParagraph key={i} value={p} className="mb-4 text-base leading-relaxed" />
        ))}
      </div>
    </div>
  );
}
